<!-- <div class="page-title-area bg-f9f9f9">
    <div class="container">
        <div class="content text-center"> -->
          <!-- <img [src]="'/assets/images/df/prices/prices01.png'" width="100%"> -->
        <!-- </div>
    </div>
</div> -->
<df-promo-banner *ngIf="memberId == 0 && bannerObj" id="promoBanner" [banner]="bannerObj"></df-promo-banner>
<div id="class-schedule" [ngClass]="{'iframe': isIframeRoute}">
    <div class="page-paginator-wrapper page-paginator-sticky" *ngIf="filteredSessions">
        <div class="row g-0">
            <div class="col-lg-6 col-md-8 col mx-auto">
                <div class="date-paginator-area">
                    <div class="date-paginator-controls">
                        <p style="position: relative;">
                            <button class="arrow left" [class.disabled]="!canGoPrev" [disabled]="!canGoPrev" (click)="goToPrev()"></button>
                            <span>{{rangeStart}}</span>
                            <span> - </span>
                            <span>{{rangeEnd}}</span>
                            <button class="arrow right" [class.disabled]="!canGoNext" [disabled]="!canGoNext" (click)="goToNext()"></button>
                        </p>
                    </div>
                    <div class="date-paginator-slider">
                        
                        <!-- You can now use your library component in app.component.html -->
                        <ngx-slick-carousel class="carousel" 
                            #slickCarousel="slick-carousel"
                            [config]="slideConfig" 
                            (init)="slickInit($event)"
                            (afterChange)="afterChange($event)"
                        >
                            <div 
                                ngxSlickItem 
                                *ngFor="let slide of slides; trackBy: trackBySlideIndex" 
                                class="slide" 
                                [ngClass]="{'disabled': slide.IsDisabled == true}"
                                [attr.data-month]="getMonth(slide.DateTime)"
                                [attr.data-date]="getDate(slide.DateTime)"
                            >
                                <div class="day">{{ getDay(slide.DateTime) }}</div>
                                <button 
                                    class="date" 
                                    (click)="onDateSelect(slide.DateTime)" 
                                    [disabled]="slide.IsDisabled" 
                                    [ngClass]="{'current' : slide.IsCurrent == true}"
                                    [attr.data-dateTime]="slide.DateTime"
                                >
                                    {{ getDate(slide.DateTime) }}
                                </button>
                            </div>
                            
                        </ngx-slick-carousel>
                        <div class="selected-date">{{currentDateStr}}</div>
                    </div>
                </div>            
            </div>
        </div>
    </div>
    <div class="session-list-wrapper">
        <div class="row g-0">
            <div class="col-lg-6 col-md-8 col mx-auto">
                <div class="sessions-wrapper" id="sessionsWrapper">
                    <ng-container *ngIf="!filteredSessions">
                        <div class="ph-item">
                            <div class="ph-col-12">
                                <div class="ph-row">
                                    <div class="ph-col-2 big"></div> <div class="ph-col-1 empty big"></div> <div class="ph-col-6 big"></div> <div class="ph-col-1 empty big"></div> <div class="ph-col-2 big"></div>
                                    <div class="ph-col-2"></div> <div class="ph-col-1 empty"></div> <div class="ph-col-6"></div> <div class="ph-col-1 empty"></div> <div class="ph-col-2"></div>
                                    <div class="ph-col-2 big"></div> <div class="ph-col-1 empty big"></div> <div class="ph-col-6 big"></div> <div class="ph-col-1 empty big"></div> <div class="ph-col-2 big"></div>
                                    <div class="ph-col-2"></div> <div class="ph-col-1 empty"></div> <div class="ph-col-6"></div> <div class="ph-col-1 empty"></div> <div class="ph-col-2"></div>
                                </div>
                            </div>
                        </div>
                        <div class="ph-item">
                            <div class="ph-col-12">
                                <div class="ph-row">
                                    <div class="ph-col-2 big"></div> <div class="ph-col-1 empty big"></div> <div class="ph-col-6 big"></div> <div class="ph-col-1 empty big"></div> <div class="ph-col-2 big"></div>
                                    <div class="ph-col-2"></div> <div class="ph-col-1 empty"></div> <div class="ph-col-6"></div> <div class="ph-col-1 empty"></div> <div class="ph-col-2"></div>
                                    <div class="ph-col-2 big"></div> <div class="ph-col-1 empty big"></div> <div class="ph-col-6 big"></div> <div class="ph-col-1 empty big"></div> <div class="ph-col-2 big"></div>
                                    <div class="ph-col-2"></div> <div class="ph-col-1 empty"></div> <div class="ph-col-6"></div> <div class="ph-col-1 empty"></div> <div class="ph-col-2"></div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                
                    <ng-container *ngIf="filteredSessions && template === 'default'">
                        <div *ngFor='let session of filteredSessions; let i = index; trackBy: trackBySessionId'  [attr.data-index]="i" (click)="onSessionRowClick(session)" class="g-0 scheduleView session-wrapper justify-content-center sessionId-{{session.Id}} session-{{getMilitaryDateText(session.StartDate)}}"  [ngClass]="session.Id == 0 ? 'header' : ''">
                            <div *ngIf="session.Id > 0" class="row">
                                <div class="col-3 time-slot">
                                    <p class="session-text">{{getTimeText(session)}}</p>
                                    <p class="session-text">{{session.Duration}} min</p>
                                </div>
                                <div class="col-9">
                                    <img src="{{session.StudioImageUrl}}" alt="{{venueName(session)}}" class="session-studio-image"/>
                                    <p *ngIf="!!session.Theme" class="session-text">{{session.Theme}}</p>
                                    <p [ngClass]="{'session-text': true, 'gray': !!session.Theme, 'smaller': !!session.Theme}">{{session.ClassName}}</p>
                                    <p *ngIf="isPartnerSession(session)" class="session-text gray">{{venueName(session)}}</p>
                                    <p class="session-text">{{screenAdoptedName(session.InstructorName)}}</p>
                                    <button *ngIf="isPartnerSession(session)" type="button" class="btn btn-secondary-outline class-book-button" (click)="showPartnerBookingNotice($event)">
                                        View only
                                    </button>
                                    <button *ngIf="!isPartnerSession(session) && isSupported() && isInFuture(session) && !isReserved(session)"
                                            [ngClass]="{'btn':true, 'btn-primary': session.SpotsLeft!==0, 'btn-secondary-outline': session.SpotsLeft===0, 'class-book-button':true}"
                                            [disabled]="isWaitlistActionLoading(session)"
                                            (click)="session.SpotsLeft === 0 ? onWaitlistActionClick(session, $event) : goToSession(session.Id)">
                                        <ng-container *ngIf="!isWaitlistActionLoading(session)">
                                            {{session.SpotsLeft === 0 ? (isInWaitlist(session) ? 'cancel waitlist' : 'join waitlist') : 'reserve'}}
                                        </ng-container>
                                        <span *ngIf="isWaitlistActionLoading(session)" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    </button>
                                    <button *ngIf="!isPartnerSession(session) && isReserved(session)"  class="btn btn-secondary-outline class-book-button" (click)="goToSession(session.Id)">
                                        Booked
                                    </button>
                                    <p *ngIf="isReserved(session) && getReservedSpot(session)" class="spots-left-text reserved-spot-text">Spot {{getReservedSpot(session)}}</p>
                                    <p *ngIf="!isPartnerSession(session) && !isReserved(session) && session.SpotsLeft > 0 && session.SpotsLeft <= 5" class="spots-left-text">{{spotsLeftText(session)}}</p>
                                </div>
                            </div>
                            <div *ngIf="session.Id === 0">
                                <p class="session-text">{{getDateText(session.StartDate)}}</p>
                            </div>
                        </div>
                        <div *ngIf="filteredSessions && !filteredSessions.length" class="no-more-classes">No sessions available at the moment</div>
                    </ng-container>

                    <ng-container *ngIf="filteredSessions && template === 'instructor'">
                        <div *ngFor='let session of filteredSessions; let i = index; trackBy: trackBySessionId'  [attr.data-index]="i" (click)="onSessionRowClick(session)" class="g-0 scheduleWithInstructorImageView session-wrapper justify-content-center sessionId-{{session.Id}} session-{{getMilitaryDateText(session.StartDate)}}"  [ngClass]="session.Id == 0 ? 'header' : ''">
                            <div *ngIf="session.Id > 0" class="row g-0">
                                <div class="col-lg-2 col-sm-2 col-2 vcenter time-slot">
                                    <p class="session-text-big">{{getTimeText(session)}}</p>
                                    <p class="session-text gray">{{session.Duration}} min</p>
                                </div>
                                <div class="col-lg-3 col-sm-3 col-3 vcenter">
                                    <img src="{{session.InstructorImageUrl}}" alt="{{session.InstructorName}}" class="session-instructor-image rounded-circle"/>
                                </div>
                                <div class="col-lg-7 col-sm-7 col-7 vcenter">
                                    <p *ngIf="!!session.Theme" class="session-text title">{{session.Theme}}</p>
                                    <p [ngClass]="{'session-text': true, 'title': !session.Theme, 'gray': !!session.Theme, 'smaller': !!session.Theme}">{{session.ClassName}}</p>
                                    <p *ngIf="isPartnerSession(session)" class="session-text gray">{{venueName(session)}}</p>
                                    <p class="session-text gray">{{screenAdoptedName(session.InstructorName)}}</p>
                                    <p class="session-text gray">{{session.AddressName}}</p>
                                    <button *ngIf="isPartnerSession(session)" type="button" class="btn btn-secondary-outline class-book-button" (click)="showPartnerBookingNotice($event)">
                                        View only
                                    </button>
                                    <button *ngIf="!isPartnerSession(session) && isSupported() && isInFuture(session) && !isReserved(session)"
                                            [ngClass]="{'btn':true, 'btn-primary': session.SpotsLeft!==0, 'btn-secondary-outline': session.SpotsLeft===0, 'class-book-button':true}"
                                            [disabled]="isWaitlistActionLoading(session)"
                                            (click)="session.SpotsLeft === 0 ? onWaitlistActionClick(session, $event) : goToSession(session.Id)">
                                        <ng-container *ngIf="!isWaitlistActionLoading(session)">
                                            {{session.SpotsLeft === 0 ? (isInWaitlist(session) ? 'cancel waitlist' : 'join waitlist') : 'reserve'}}
                                        </ng-container>
                                        <span *ngIf="isWaitlistActionLoading(session)" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    </button>
                                    <button *ngIf="!isPartnerSession(session) && isReserved(session)"  class="btn btn-secondary-outline class-book-button" (click)="goToSession(session.Id)">
                                        Booked
                                    </button>
                                    <p *ngIf="isReserved(session) && getReservedSpot(session)" class="spots-left-text reserved-spot-text">Spot {{getReservedSpot(session)}}</p>
                                    <p *ngIf="!isPartnerSession(session) && !isReserved(session) && session.SpotsLeft > 0 && session.SpotsLeft <= 5" class="spots-left-text">{{spotsLeftText(session)}}</p>
                                </div>
                            </div>
                            <div *ngIf="session.Id === 0">
                                <p class="session-text">{{getDateText(session.StartDate)}}</p>
                            </div>
                        </div>
                        <div *ngIf="filteredSessions && !filteredSessions.length" class="no-more-classes">No sessions available at the moment</div>
                    </ng-container>
                
                    <ng-container *ngIf="filteredSessions && template === 'compact'">
                        <div *ngFor='let session of filteredSessions; trackBy: trackBySessionId' (click)="onSessionRowClick(session)" class="g-0 studioView instructorView session-wrapper justify-content-center sessionId-{{session.Id}} session-{{getMilitaryDateText(session.StartDate)}}">
                            <div class="row">
                                <div class="col-3">
                                    <p class="session-text">{{getDayText(session.StartDate)}}</p>
                                    <p class="session-text">{{getDateText(session.StartDate)}}</p>
                                    <p class="session-text">{{getTimeText(session)}}</p>
                                    <p class="session-text">{{session.Duration}} min</p>
                                </div>
                                <div class="col-9">
                                    <img src="{{session.StudioImageUrl}}" alt="{{venueName(session)}}" class="session-studio-image"/>
                                    <p *ngIf="!!session.Theme" class="session-text">{{session.Theme}}</p>
                                    <p [ngClass]="{'session-text': true, 'gray': !!session.Theme, 'smaller': !!session.Theme}">{{session.ClassName}}</p>
                                    <p *ngIf="isPartnerSession(session)" class="session-text gray">{{venueName(session)}}</p>
                                    <p class="session-text">{{session.InstructorName}}</p>
                                    <button *ngIf="isPartnerSession(session)" type="button" class="btn btn-secondary-outline class-book-button" (click)="showPartnerBookingNotice($event)">
                                        View only
                                    </button>
                                    <button *ngIf="!isPartnerSession(session) && isSupported() && isInFuture(session)"  class="btn btn-primary class-book-button">
                                        reserve
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="filteredSessions && !filteredSessions.length" class="no-more-classes">No sessions available at the moment</div>
                    </ng-container>
                    <button *ngIf="showLoadMore && filteredSessions && hasActualSessions()"
                        [ngClass]="{'btn':true, 'btn-primary': true, 'btn-secondary-outline': true, 'load-more-button':true}"
                        (click)="onLoadMore()">
                        Load More
                    </button>
                    <ng-container *ngIf="filteredSessions">
                        <div class="filters" [ngClass]="{'fixed': filteredSessions && filteredSessions.length > 0, 'absolute': !(filteredSessions && filteredSessions.length > 0)}">
                            <ul class="filter-list">
                                <li>
                                    <a href="javascript:void(0)" (click)="filterSessions()" class="btn btn-secondary-outline filter-button">
                                        <i class="fa fa-sliders" aria-hidden="true"></i>
                                        <span class="name" style="margin: 10px 10px;">Filters</span>
                                        <span *ngIf="filterCount > 0" class="filter-count">{{filterCount}}</span>
                                    </a>
                                </li>
                                <ng-container *ngIf="partnerLocations.length">
                                    <li>
                                        <label [class.selected]="isHostScheduleSelected()">
                                        <input
                                            type="checkbox"
                                            [checked]="isHostScheduleSelected()"
                                            (change)="selectHostSchedule()"
                                            hidden
                                        />
                                        {{ hostScheduleLabel }}
                                        </label>
                                    </li>
                                    <li *ngFor="let partner of partnerLocations">
                                        <label [class.selected]="isPartnerLocationSelected(partner.key)">
                                        <input
                                            type="checkbox"
                                            [checked]="isPartnerLocationSelected(partner.key)"
                                            (change)="selectPartnerLocation(partner.key)"
                                            hidden
                                        />
                                        {{ partner.name }}
                                        </label>
                                    </li>
                                </ng-container>
                                <ng-container *ngIf="quickFilter == 'address' && isHostScheduleSelected()">
                                    <li *ngFor="let address of addresses">
                                        <label [class.selected]="isAddressSelected(address.Id)">
                                        <input 
                                            type="checkbox" 
                                            [checked]="isAddressSelected(address.Id)" 
                                            (change)="toggleAddressFilter(address.Id)"
                                            hidden 
                                        />
                                        {{ address.Name }}
                                        </label>
                                    </li>
                                </ng-container>
                                <ng-container *ngIf="quickFilter == 'studio'">
                                    <li *ngFor="let studio of studios">
                                        <label [class.selected]="isStudioSelected(studio.Id)">
                                        <input 
                                            type="checkbox" 
                                            [checked]="isStudioSelected(studio.Id)" 
                                            (change)="toggleStudioFilter(studio.Id)"
                                            hidden 
                                        />
                                        {{ studio.Name }}
                                        </label>
                                    </li>
                                </ng-container>
                                <ng-container *ngIf="quickFilter == 'instructor'">
                                    <li *ngFor="let instructor of instructors">
                                        <label [class.selected]="isInstructorSelected(instructor.Id)">
                                        <input 
                                            type="checkbox" 
                                            [checked]="isInstructorSelected(instructor.Id)" 
                                            (change)="toggleInstructorFilter(instructor.Id)"
                                            hidden 
                                        />
                                        {{ instructor.Person.FullName }}
                                        </label>
                                    </li>
                                </ng-container>
                                <ng-container *ngIf="quickFilter == 'location'">
                                    <li *ngFor="let location of locations">
                                        <label [class.selected]="isLocationSelected(location.Id)">
                                        <input 
                                            type="checkbox" 
                                            [checked]="isLocationSelected(location.Id)" 
                                            (change)="toggleLocationFilter(location.Id)"
                                            hidden 
                                        />
                                        {{ location.Name }}
                                        </label>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>